import {Component, EventEmitter, Output} from '@angular/core';
import {GeneralSymbolsEncodingComponent} from '../general-symbol-encoding/g-symbols-encoding.component';

@Component({
  selector: 'app-symbols-encoding-defect',
  templateUrl: '../general-symbol-encoding/symbols-encoding-image.component.html',
  styleUrls: ['../general-symbol-encoding/symbols-encoding-image.component.css']
})
export class SymbolsEncodingDefectComponent extends GeneralSymbolsEncodingComponent {

  @Output() isGoodEncodingChange = new EventEmitter<boolean>();
  @Output() defectEncodingChange = new EventEmitter<number[]>();

  defectCounter = 0;

  generateRandomExercise() {
    this.initValues();

    const numberOfEncodings = this.getNumberOfEncodings();
    const lengthOfEncoding = this.getEncodingLength();
    const goodCoding = Math.floor((Math.random() * 2));

    this.generateAllEncodings(lengthOfEncoding);

    if (goodCoding) {
      this.generateGoodCoding(numberOfEncodings);
      this.encodings = this.goodEncoding;
    } else {
      this.generateCoding(numberOfEncodings);
      this.encodings = this.generalEncoding;
    }
    this.currentEncodingChange.emit(this.encodings);
  }

  /**
   * Returns the number of words that we want to encode
   */
  getNumberOfEncodings() {
    if (this.level === 1) {
      return 3;
    } else if (this.level === 2) {
      return 4;
    } else {
      return 5;
    }
  }

  /**
   * Returns the length of all the encodings.
   * The number of symbols an encodings consist of.
   */
  getEncodingLength() {
    if (this.level === 1) {
      return 3;
    }  else {
      return 4;
    }
  }

  generateGoodCoding(numberOfEncodings: number) {
    super.generateGoodCoding(numberOfEncodings);

    const randCodingIdx = Math.floor((Math.random() * (numberOfEncodings)));
    const defectCoding = Object.assign([], this.goodEncoding[randCodingIdx]);
    const randIdx = Math.floor((Math.random() * defectCoding.length));
    defectCoding[randIdx] = -1;

    this.defectEncodingChange.emit(defectCoding);
  }

  generateCoding(numberOfEncodings: number) {
    super.generateCoding(numberOfEncodings);

    let randCodingIdx;
    let randIdx;
    let defectCoding;

    if (this.defectCounter < this.counter / 5) {
      this.defectCounter ++;
      // Two of the encodings have only one difference.
      let counter = 0;
      while (counter < 1) {
        randCodingIdx = Math.floor((Math.random() * (numberOfEncodings)));
        const tempCoding = Object.assign([], this.generalEncoding[randCodingIdx]);
        randIdx = Math.floor((Math.random() * tempCoding.length));
        if (tempCoding[randIdx] === 0) {
          tempCoding[randIdx] = 1;
        } else {
          tempCoding[randIdx] = 0;
        }
        console.log(tempCoding);
        if (this.generalEncoding.findIndex(i => this.compareArrays(i, tempCoding)) === -1) {
          let randPosition = Math.floor((Math.random() * (numberOfEncodings)));
          if (randPosition === randCodingIdx) {
            randPosition = (randPosition + 1) % tempCoding.length;
          }
          console.log(randPosition);
          this.generalEncoding.splice(randPosition, 1, tempCoding);
          counter++;
        } else {
          counter ++;
        }
      }
      defectCoding = Object.assign([], this.generalEncoding[randCodingIdx]);
      defectCoding[randIdx] = -1;
    } else {
      randCodingIdx = Math.floor((Math.random() * (numberOfEncodings)));
      defectCoding = Object.assign([], this.generalEncoding[randCodingIdx]);
      randIdx = Math.floor((Math.random() * defectCoding.length));
      defectCoding[randIdx] = -1;
    }

    this.defectEncodingChange.emit(defectCoding);
  }

}
